<div class="flex flex-col grow h-full w-full">
  @if (!isLandingPage) {
    <app-nav-bar></app-nav-bar>
  }

  <div>
    <router-outlet></router-outlet>
  </div>

  @if (!isLandingPage) {
    <app-footer></app-footer>
  }
</div>
